export enum OrdersPeriodFilter {
    WEEK = 'Past week',
    MONTH = 'Past month',
    YEAR = 'Past year'
}

// export interface OrderAttributes { // TODO-A Order details, this may changea after bd is ready
//     attributeName: string;
//     id: number;
//     name: string;
//     type: string;
//     value: string;
// }

// export interface OrderDetails { // TODO-A Order details, this may changea after bd is ready
//     name: string;
//     price: number;
//     attributes: OrderAttributes[];
// }
export interface UserOrdersDTO {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
}

export interface OrdersDTO {
  id: number;
  number: number;
  date: string;
  price: number;
  orderStatus: string;
  errorStatus: string;
  shop: number;
  externalId: number;
  user: UserOrdersDTO;
  products: any;
  store: {
    id: string;
    name: string;
    shopifyAccessToken: string;
    shopifyStoreUrl: string;
  }; // TODO-A Order details. To add correct DTOs here later.
  // details: OrderDetails[]; // TODO-A Order details, this may changea after bd is ready
  shopifyOrderId?: number; // For Shopify integration
  shopifyProcessStatus?: string; // For Shopify integration
}